import React, { useEffect, useState } from "react";
import { Bonus } from "../../../types/bonus";
import ReactModal from "react-modal";
import { getDate } from "../../../helpers/dateHelper";
import { AppButton } from "../../common/ctaButton/button";
import { BonusDrawIcon } from "./BonusIcon";
import { Raffle } from "../../../types/raffle";

interface BonusViewModalProps {
  bonus: Bonus;
  closeModal: () => void;
  showModal: boolean;
  raffles: Array<Raffle>;
}

export const BonusViewModal = ({
  bonus,
  closeModal,
  showModal,
  raffles,
}: BonusViewModalProps) => {
  const [rafflesList, setRafflesList] = useState<Array<Raffle>>([]);

  const getRafflesList = () => {
    const currentRafflesList: Array<Raffle> = [];
    bonus.raffles.forEach((raffleId) => {
      // console.log("rafflesraffles: ", raffles);

      const currentRaffle = raffles.find((raffle) => raffle._id === raffleId);
      if (currentRaffle) {
        // console.log("currentRaffle", currentRaffle);
        currentRafflesList.push(currentRaffle);
      }
    });

    setRafflesList(currentRafflesList);
  };

  useEffect(() => {
    if (bonus && raffles) {
      getRafflesList();
    }
  }, []);

  console.log("rafflesList", rafflesList);

  return (
    <>
      {bonus && (
        <ReactModal
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          appElement={document.getElementById("root")}
          onClose={closeModal}
          isOpen={showModal}
          contentLabel="Inline Styles Modal Example"
          className="globalModalWrapper"
          style={{
            overlay: {
              backgroundColor: "rgba(9, 16, 29, 0.6)",
              zIndex: 10,
              width: "100%",
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <div className="couponModalContentWrapper">
            <div className="modalHeader">
              <span>View Bonus details:</span>
            </div>
            <div className="modalBody modalBody_view">
              <div className="modal-bonus-details-list">
                <div className="modal-bonus-details-item">
                  <p className="modal-bonus-details-item__label">Page Title:</p>
                  <p className="modal-bonus-details-item__value">
                    {bonus.pageTitle}
                  </p>
                </div>
                <div className="modal-bonus-details-item">
                  <p className="modal-bonus-details-item__label">
                    Profile Title:
                  </p>
                  <p className="modal-bonus-details-item__value">
                    {bonus.profileTitle}
                  </p>
                </div>
                <div className="modal-bonus-details-item">
                  <p className="modal-bonus-details-item__label">Meta Title:</p>
                  <p className="modal-bonus-details-item__value">
                    {bonus.metaTitle}
                  </p>
                </div>
                <div className="modal-bonus-details-item">
                  <p className="modal-bonus-details-item__label">
                    Badge Color:
                  </p>
                  <p className="modal-bonus-details-item__value">
                    {bonus.color}
                  </p>
                  <BonusDrawIcon color={bonus.color} />
                </div>
                <div className="modal-bonus-details-item">
                  <p className="modal-bonus-details-item__label">Start:</p>
                  <p className="modal-bonus-details-item__value">
                    {getDate(new Date(bonus.startAt))}
                  </p>
                </div>
                <div className="modal-bonus-details-item">
                  <p className="modal-bonus-details-item__label">End:</p>
                  <p className="modal-bonus-details-item__value">
                    {getDate(new Date(bonus.endAt))}
                  </p>
                </div>
                <div className="modal-bonus-details-item">
                  <p className="modal-bonus-details-item__label">Price:</p>
                  <p className="modal-bonus-details-item__value">
                    £{bonus.price}
                  </p>
                </div>
                <div className="modal-bonus-details-item">
                  <p className="modal-bonus-details-item__label">Active:</p>
                  <p className="modal-bonus-details-item__value">
                    {bonus.isActive.toString()}
                  </p>
                </div>
                <div className="modal-bonus-details-item modal-bonus-details-item--lg">
                  <p className="modal-bonus-details-item__label">
                    Meta Description:
                  </p>
                  <p className="modal-bonus-details-item__value">
                    {bonus.metaDescription}
                  </p>
                </div>
                <div className="modal-bonus-details-item modal-bonus-details-item--lg">
                  <p className="modal-bonus-details-item__label">
                    Associated Raffles:
                  </p>
                  <p className="modal-bonus-details-item__value modal-bonus-details-item__value--list">
                    {rafflesList && rafflesList.length
                      ? rafflesList.map((raffle) => {
                          return (
                            <span>
                              {raffle.title}
                              {raffle.active ? (
                                <span className="modal-bonus-details-item__active-label">active</span>
                              ) : null}
                            </span>
                          );
                        })
                      : null}
                  </p>
                </div>
              </div>
            </div>
            <div className="modalFooter">
              <AppButton onClick={closeModal} size="long" text="Ok" />
            </div>
          </div>
        </ReactModal>
      )}
    </>
  );
};
